import axios from "axios";
import router from "@/router";
import api from "@/api";

export const reportOrderHelpersModule = {
    namespaced: true,

    state: () => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            console.log(data);
            state.reportData = data;
            state.reportLoading = false;
        },

        setReportFilterset(state, data) {
            state.filterSpecs['shop'] = []
            state.filterSpecs['store'] = []
            state.filterSpecs['date_range'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else {
                                if(data[filter].choices[i].checked) {
                                    if(data[filter].multi_choices) {
                                        state.filterSpecs[filter].push(data[filter].choices[i].value)
                                    } else {
                                        state.filterSpecs[filter] = data[filter].choices[i].value
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query

                state.filterSpecs['date_range'] = []

                queries.date_from ? state.filterSpecs['date_range'].push(queries.date_from) : state.filterSpecs['date_range'].push('')
                queries.date_to ? state.filterSpecs['date_range'].push(queries.date_to) : state.filterSpecs['date_range'].push('')
                queries.shop ? state.filterSpecs['shop'] = queries.shop : state.filterSpecs['shop'] = state.points_of_sale[0].value
                queries.search_name ? state.filterSpecs['search_name'] = queries.search_name : state.filterSpecs['search_name'] = ''
                queries.store ? state.filterSpecs['store'] = queries.store : state.filterSpecs['store'] = []
            }
            
            state.filterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data;
        },

        setChangedRow(state, data) {
            state.reportData.rows[data.index] = data.row
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true;
            // Проверяет, есть ли параметры которые можно передать в запросе
            if (router.currentRoute.value.fullPath.split("?")[1]) {
                try {
                    const response = await axios.get(
                        api + "reports/order_helpers/data?" +
                            router.currentRoute.value.fullPath.split("?")[1],
                        {
                            headers: {
                                Authorization: "Token " + localStorage.getItem("token"),
                            },
                        }
                    );
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
                // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await axios.get(api + "reports/order_helpers/data", {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                    });
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
            }
        },

        async getReportFilterset({ commit }) {
            try {
                const response = await axios.get(api + "reports/order_helpers/filterset", {
                    headers: {
                        Authorization: "Token " + localStorage.getItem("token"),
                    },
                });
                commit("setReportFilterset", response.data);
            } catch (err) {
                // Если есть ошибка
                console.log(err)
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await axios.post(
                    api + "reports/export_to_excel/",
                    state.excelData,
                    {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                        responseType: "blob",
                    }
                );
                const now = new Date();
                const url = URL.createObjectURL(response.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                // Если есть ошибка
                alert(err);
            }
        },

        async changeRowData({ commit }, data) {
            

            if(data.row) {
                for(let i = 0; i < data.row.length; i++) {
                    if(data.row[i].editable) {
                        data.row[i].value = data.row[i].value.replace(/,/g, ".")
                    }
                }
                
                try {
                    const response = await axios.post(api + "reports/order_helpers/edit/row/",
                    {
                        data: data.row
                    },
                    {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                    });

                    if(response.status == 200) {
                        commit("setChangedRow", { index: data.index, row: response.data })
                    }
                } catch (err) {
                    // Если есть ошибка
                    console.log(err)
                }
            }
        }
    },
};
